/* istanbul ignore file */
import { useEffect } from 'react';
import type { GenericTrackingEvent } from '@packages/tracking';
import { useTracking } from '@packages/tracking';
import type { RdeType } from '../../types';

type GtmEvent = {
  sourceCategoryId?: string | number;
  rdeTypeAbbr: string;
  outputElementNo: number;
};

type TrackingProps = {
  rdeType: RdeType;
  elementIndex?: number;
  trackingCondition: boolean;
  sourceCategoryId: string | number;
};

export const useCategoriesRecoTracking = ({
  rdeType,
  elementIndex,
  sourceCategoryId,
  trackingCondition,
}: TrackingProps) => {
  const dispatchGTMEvent = useTracking();

  useEffect(() => {
    if (trackingCondition) {
      dispatchGTMEvent<GenericTrackingEvent<GtmEvent>>({
        event: 'ga_event',
        eventAction: 'view',
        eventCategory: 'elementImpression',
        eventLabel: 'categoryRecoImpression',
        eventValue: {
          rdeTypeAbbr: rdeType,
          outputElementNo: (elementIndex ?? 0) + 1,
          sourceCategoryId,
        },
      });
    }
  }, [dispatchGTMEvent, elementIndex, rdeType, sourceCategoryId, trackingCondition]);
};
